const faultWarningEn = {
  faultWarnLang: {
    请输入站点名称搜索: 'Please enter the station name',
    暂无数据: 'No data available',
    重置站点告警: 'Reset station warning',
    重置系统告警: 'Reset system warning',
    历史告警: 'Historical alarms',
    设备类型: 'Device type',
    全部: 'All',
    全选: 'Select All',
    告警等级: 'Warning level',
    告警类型: 'Alarm type',
    故障状态: 'Fault status',
    告警状态: 'Alarm status',
    处理建议: 'Treatment suggestion',
    时间范围: 'Time frame',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    查询: 'Query',
    重置: 'Reset',
    站点系统: 'Site System',
    告警统计: 'Alarm statistics',
    告警列表: 'Alarm List',
    '已结束告警记录只保留近7日，更多告警信息请前往右上角告警历史查看':
      'The finished alarm record is only kept for nearly 7 days. For more alarm information, please go to "alarm History" in the upper right corner.',
    设备名称: 'Device name',
    告警标题: 'Alarm title',
    客户告警: 'Customer alarm',
    告警开始时间: 'Alarm start time',
    告警结束时间: 'Alarm end time',
    操作: 'Operation',
    结束: 'End',
    删除: 'Delete',
    详情: 'Details',
    结束告警: 'End alarm',
    时区: 'Time zone',
    请选择: 'Please select',
    取消: 'Cancel',
    确定: 'Confirm',
    运维告警详情: 'O&M alarm details',
    返回: 'Return',
    复制成功: 'Copy success',
    请选择时间: 'Please select a time!',
    发生中: 'In progress',
    已结束: 'Ended',
    未分级: 'Ungraded',
    一般: 'Normal',
    重要: 'Important',
    严重: 'Serious',
    设备: 'Device',
    业务: 'Business',
    通讯: 'Communication',
    运维处理: 'O&M handling',
    此操作将清除当前站点下全部系统的告警历史及统计数据是否确认清除:
      'This operation will clear the alarm history and statistical data of all stations under the current site. Are you sure to clear it?',
    提示: 'Hint',
    此操作前提是必须先选择指定站点系统: 'The premise of this operation is to select the specified site system first!',
    此操作将清除当前系统下全部系统的告警历史及统计数据是否确认清除:
      'This operation will clear the alarm history and statistical data of all systems under the current system. Are you sure to clear it?',
    结束时间不能小于开始时间: 'The end time cannot be earlier than the start time.',
    是否删除此告警: 'Do you want to delete this alarm?',
    站点告警: 'Site alarm',
    告警筛选: 'Alarm filtering',
    '时间范围只能选择1-7天': 'The time range can only be selected from 1-7 days',
    条: ''
  }
}
export default faultWarningEn
